import * as React from "react"

import type { NamedRoutes } from "shared/utils/routes"

import Charges from "./Charges"
import Deals from "./Deals"
import Discounts from "./Discounts"
import OptionLists from "./OptionLists"
import Products from "./Products"

export const namedRoutes: NamedRoutes = {
  products: {
    pathTemplate: "products",
    element: <Products />,
  },
  product: {
    pathTemplate: "products/:productId",
    element: <Products />,
  },
  category: {
    pathTemplate: "products/category/:categoryId",
    element: <Products />,
  },
  option_lists: {
    pathTemplate: "option_lists",
    element: <OptionLists />,
  },
  option_list: {
    pathTemplate: "option_lists/:optionListId",
    element: <OptionLists />,
  },
  deals: {
    pathTemplate: "deals",
    element: <Deals />,
  },
  deal: {
    pathTemplate: "deals/:dealId",
    element: <Deals />,
  },
  discounts: {
    pathTemplate: "discounts",
    element: <Discounts />,
  },
  discount: {
    pathTemplate: "discounts/:discountId",
    element: <Discounts />,
  },
  charges: {
    pathTemplate: "charges",
    element: <Charges />,
  },
  charge: {
    pathTemplate: "charges/:chargeId",
    element: <Charges />,
  },
}
